export default __webpack_public_path__ + "images/Svay-Sach-Phnum-floor-tiles.webp";